import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';
import { knowledgeGraphModule } from './knowledgeGraphModule';
import { knowledgePageModule } from './knowledgePageModule';

const URL = {};

class KnowledgeModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {};

  modules = {
    knowledgeGraph: knowledgeGraphModule,
    knowledgePage: knowledgePageModule,
  };
}

export const knowledgeModule = new KnowledgeModule();
